import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-maschine-list-view',
  imports: [],
  templateUrl: './maschine.list-view.html',
  styleUrls: ['./maschine.list-view.css'],
})
export class MaschineListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
